// "Instalar aplicación / Install application" affordance (roadmap #100). Staff-only:
// rendered exclusively from StaffDashboard.tsx, never from the public guest call
// flow. See staff/installPrompt.ts for the beforeinstallprompt wiring and the
// browser-support feature detection.
import { useState } from 'react'
import { t } from '../i18n'
import { useInstallPrompt } from './installPrompt'

const InstallAppButton = () => {
  const { showAffordance, canPromptNatively, promptInstall } = useInstallPrompt()
  const [showFallback, setShowFallback] = useState(false)

  if (!showAffordance) return null

  const onClick = () => {
    if (canPromptNatively) {
      void promptInstall()
    } else {
      // No installation support in this browser at all (e.g. Firefox/Safari):
      // recommend a compatible one by name instead of attempting a prompt.
      setShowFallback(true)
    }
  }

  return (
    <>
      <div className="cf-help">
        {t.installAppHint}
        <button type="button" className="cf-btn cf-btn-secondary" onClick={onClick}>
          {t.installAppButton}
        </button>
      </div>

      {showFallback && (
        <div className="cf-modal-backdrop" role="dialog" aria-modal="true">
          <div className="cf-modal">
            <h2 className="cf-modal-title">{t.installFallbackTitle}</h2>
            <p className="cf-modal-body">{t.installFallbackBody}</p>
            <div className="cf-modal-actions">
              <button type="button" className="cf-btn cf-btn-primary" onClick={() => setShowFallback(false)}>
                {t.installFallbackClose}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default InstallAppButton
